import { Auth } from 'aws-amplify'
import type { AxiosError } from 'axios'
import { put } from 'redux-saga/effects'

import config from '../config'
import { showBackdropMessage } from '../redux/message/actions'

export function* handleUnAuthorizedError(e: AxiosError) {
  if (e?.response?.status === 401) {
    yield put(
      showBackdropMessage([
        'Your login token has either invalid or has expired, please log in again',
        'Logging you out in 3 seconds'
      ])
    )
    setTimeout(() => {
      void Auth.signOut()
    }, config.delayMS.forceLogout)
  }
}
